import { errorHttpMessage } from "@/utils/errorDecodeUtil";
import voicesOfChangeService from "@/services/voicesOfChangeService";

export const getData = async ({ commit }) => {
    try {
        commit('setLoading', true)
        // Replace with actual service call
        // const { data: response } = await voicesOfChangeService.getData();
        
        // Mock response for now
        const response = {
            result: {
                data: {},
                message: 'Data retrieved successfully'
            }
        }
        
        commit('setData', response.result.data)
        return response.result;
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        commit('setError', error_http_message?.message)
        return {
            message: error_http_message?.message,
            error_keys: error_http_message?.error_keys,
            data: ex?.response?.data,
            error: true,
        };
    } finally {
        commit('setLoading', false)
    }
}

export const saveData = async ({ commit }, payload) => {
    try {
        commit('setLoading', true)
        // Replace with actual service call
        // const { data: response } = await voicesOfChangeService.saveData(payload);
        
        // Mock response for now
        const response = {
            result: {
                data: payload,
                message: 'Data saved successfully'
            }
        }
        
        commit('setData', response.result.data)
        return response.result;
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        commit('setError', error_http_message?.message)
        return {
            message: error_http_message?.message,
            error_keys: error_http_message?.error_keys,
            data: ex?.response?.data,
            error: true,
        };
    } finally {
        commit('setLoading', false)
    }
}

export const resetData = ({ commit }) => {
    commit('resetState')
}

// Categories actions
export const getRecordedTalksCategories = async ({ commit }) => {
    try {
        commit('setCategoriesLoading', true)
        const { data: response } = await voicesOfChangeService.getRecordedTalksCategories();
        commit('setCategories', response.result.data)
        return response.result;
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        commit('setError', error_http_message?.message)
        return {
            message: error_http_message?.message,
            error_keys: error_http_message?.error_keys,
            data: ex?.response?.data,
            error: true,
        };
    } finally {
        commit('setCategoriesLoading', false)
    }
}

export const selectCategory = ({ commit }, category) => {
    commit('setSelectedCategory', category)
}

// Recorded talks actions
export const getRecordedTalksByCategory = async ({ commit }, categoryId) => {
    try {
        commit('setTalksLoading', true)
        const { data: response } = await voicesOfChangeService.getRecordedTalksByCategory(categoryId);
        commit('setRecordedTalksByCategory', { categoryId, talks: response.result.data })
        return response.result;
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        commit('setError', error_http_message?.message)
        return {
            message: error_http_message?.message,
            error_keys: error_http_message?.error_keys,
            data: ex?.response?.data,
            error: true,
        };
    } finally {
        commit('setTalksLoading', false)
    }
}

export const getRecordedTalkDetails = async ({ commit }, talkId) => {
    try {
        commit('setLoading', true)
        const { data: response } = await voicesOfChangeService.getRecordedTalkDetails(talkId);
        commit('setSelectedRecordedTalk', response.result.data)
        return response.result;
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        commit('setError', error_http_message?.message)
        return {
            message: error_http_message?.message,
            error_keys: error_http_message?.error_keys,
            data: ex?.response?.data,
            error: true,
        };
    } finally {
        commit('setLoading', false)
    }
}

export const toggleFavoriteRecordedTalk = async ({ commit }, { talkId, isFavorite }) => {
    try {
        const { data: response } = await voicesOfChangeService.toggleFavoriteRecordedTalk({
            talk_id: talkId,
            is_favorite: isFavorite
        });
        commit('updateRecordedTalkFavorite', { talkId, isFavorite })
        return response.result;
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        return {
            message: error_http_message?.message,
            error_keys: error_http_message?.error_keys,
            data: ex?.response?.data,
            error: true,
        };
    }
}

export const markRecordedTalkAsViewed = async ({ commit }, talkId) => {
    try {
        const { data: response } = await voicesOfChangeService.markRecordedTalkAsViewed(talkId);
        return response.result;
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        return {
            message: error_http_message?.message,
            error_keys: error_http_message?.error_keys,
            data: ex?.response?.data,
            error: true,
        };
    }
}

export const getFavoriteRecordedTalks = async ({ commit }) => {
    try {
        commit('setTalksLoading', true)
        const { data: response } = await voicesOfChangeService.getFavoriteRecordedTalks();
        commit('setFavoriteRecordedTalks', response.result.data)
        return response.result;
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        commit('setError', error_http_message?.message)
        return {
            message: error_http_message?.message,
            error_keys: error_http_message?.error_keys,
            data: ex?.response?.data,
            error: true,
        };
    } finally {
        commit('setTalksLoading', false)
    }
}

// Last upcoming talk action
export const getLastUpcomingTalk = async ({ commit }) => {
    try {
        commit('setLastUpcomingTalkLoading', true)
        const { data: response } = await voicesOfChangeService.getLastUpcomingTalk();
        commit('setLastUpcomingTalk', response.result.data)
        return response.result;
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        commit('setError', error_http_message?.message)
        return {
            message: error_http_message?.message,
            error_keys: error_http_message?.error_keys,
            data: ex?.response?.data,
            error: true,
        };
    } finally {
        commit('setLastUpcomingTalkLoading', false)
    }
} 

// Admin: soft delete recorded talk
export const softDeleteRecordedTalk = async ({ commit }, talkId) => {
    try {
        const { data: response } = await voicesOfChangeService.deleteRecordedTalk(talkId)
        return response
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        return {
            message: error_http_message?.message,
            error_keys: error_http_message?.error_keys,
            data: ex?.response?.data,
            error: true,
        };
    }
}

// Admin: store recorded talk
export const storeRecordedTalk = async ({ commit }, formData) => {
    try {
        commit('setLoading', true)
        const { data: response } = await voicesOfChangeService.saveRecordedTalk(formData);
        return response.result;
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        commit('setError', error_http_message?.message)
        return {
            message: error_http_message?.message,
            error_keys: error_http_message?.error_keys,
            data: ex?.response?.data,
            error: true,
        };
    } finally {
        commit('setLoading', false)
    }
}

// Admin: update recorded talk
export const updateRecordedTalk = async ({ commit }, { id, data }) => {
    try {
        commit('setLoading', true)
        const { data: response } = await voicesOfChangeService.updateRecordedTalk(id, data);
        return response.result;
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        commit('setError', error_http_message?.message)
        return {
            message: error_http_message?.message,
            error_keys: error_http_message?.error_keys,
            data: ex?.response?.data,
            error: true,
        };
    } finally {
        commit('setLoading', false)
    }
}